<template>
    <!-- <app-layout> -->


    <div class="mx-auto flex flex-grow flex-col" :class="{ '-mt-6': is_visitor }"
        style="background-image: url(/img/birdie-icon-pattern.svg);">

        <div class="w-full h-full bg-birdie-dark bg-opacity-70">

            <div
                class="flex flex-grow h-full flex-col justify-start items-center relative overflow-y-scroll bg-birdie-dark bg-opacity-70">
                <div class="flex w-full max-w-screen-lg">
                    <div
                        class="mb-0 mt-4 md:mt-0 mx-auto relative flex overflow-hidden justify-center items-center px-10 ">

                        <div class="blurcs_md mt-10 p-5 flex">
                            <img src="/img/screenrecording-home2.png" class="opacity-50" />
                        </div>

                        <div
                            :class="[plan_screenrecording ? 'justify-center' : 'justify-end', 'absolute flex flex-grow w-full h-full flex-col items-center']">


                            <div class="bg-white p-20 rounded-xl shadow-xl text-center">

                                <p v-if="!is_visitor" class="font-bold">You did not enable Screen Recording.</p>
                                <p v-if="!is_visitor" class="mt-3">You must enable the option in your settings.</p>

                                <p v-if="is_visitor" class="font-bold">Screen Recording has been disabled<br />in this
                                    Birdie account.</p>


                                <p v-if="$page.props.canManageSettings && !is_visitor">
                                    <inertia-link :href="route('settings.incoming')" title="Go to Settings"
                                        class="mt-5 border-gray-500 inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 disabled:opacity-25 transition">
                                        <span>Enable </span>
                                        <vue-feather type="arrow-right" class="h-4 w-4 ml-2"></vue-feather>
                                    </inertia-link>
                                </p>
                                <div v-else-if="!is_visitor">
                                    <div title="Go to Settings"
                                        class="mt-5 border-gray-500 inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest opacity-25">
                                        <span>Enable </span>
                                        <vue-feather type="arrow-right" class="h-4 w-4 ml-2"></vue-feather>
                                    </div>
                                    <div class="text-sm text-center">(An administrator account is needed)</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- </app-layout> -->
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'

export default {
    props: ['screenrecording_enabled', 'plan_screenrecording', 'is_visitor'],
    components: {
        AppLayout,
    },
    layout: AppLayout, // keep layout in place avoid refreshing it
    data() {
        return {

        }
    },
    created() {
        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
    },
    beforeUnmount() {
        // this.EventBus.off("start.call", this.test);
    },
    mounted() {
        // this.EventBus.emit("start.call", "hello")
    },
    methods: {
        // test(toto) {
        //     console.log("test ok", toto)
        // }
    }
}
</script>
